// Sunday Terms, version 2026-11-01. DRAFT: waits for Braeden, Brenna and counsel.
// Never edit a released version. To change the terms, add a new file with a new
// date and point CURRENT_SUNDAY_TERMS in ./index.js at it (sundayTerms.test.js
// fails if a released file changes).

const terms = {
  version: '2026-11-01',
  title: 'Sunday Terms for Hosts',
  intro:
    'Version 2026-11-01. These Sunday Terms add to the Yedding Terms of Service and Host Terms. If they conflict about a Sunday Event, these Sunday Terms apply.',
  sections: [
    {
      heading: '1. Why these terms exist.',
      text: 'Our team does not work on Sundays. On a Sunday we do not answer calls, texts or emails, except in a life-threatening emergency (item 3.6), and we do not come to your property. If you open Sundays, you run the whole event day yourself. We want you and your guests to have a great day, so please read this carefully.'
    },
    {
      heading: '2. What a Sunday Event is.',
      text: "A Sunday Event is any booking, or any part of a booking, that falls on a Sunday, from 12:00 a.m. to 11:59 p.m. in the venue's local time. This includes set-up, clean-up, and any part of a Saturday event that goes past midnight."
    },
    {
      heading: '3. What you agree to do.',
      text: 'For every Sunday Event, you agree to:',
      list: [
        'Have an on-site contact: you, or an adult you name below. They stay on the property for the whole event, and can reach the event area within 5 minutes.',
        "Keep the on-site contact's full name and phone number up to date in your venue editor. We show them to the booker in their Reservations on yedding.com on the Monday before the event.",
        'Open and close the property, and greet the booker or their lead contact at the agreed-upon times.',
        'Enforce your listing rules: guest count, allowed areas, parking, noise, alcohol and end time.',
        'Handle any problem as it happens, such as complaints, damage, injury, neighbors, weather, power or water.',
        'In a life-threatening emergency, call 911 first. Then call Braeden at Yedding: 615-992-8355.',
        "Take dated photos of any damage or write down any broken rules during the event, and report it to support@yedding.com within 3 days of the event. *See the related policy in Yedding's Host Agreement."
      ]
    },
    {
      heading: '4. If no one is on site.',
      text: 'If neither you nor your on-site contact is on the property during a Sunday Event, you have broken these terms. You are responsible for any loss, damage or injury that results, to the fullest extent the law allows. Yedding may also close Sundays at your venues, [refund the booker from your payout], and [remove your listing].'
    },
    {
      heading: '5. What Yedding does.',
      text: 'Before a booker pays for a Sunday Event, we tell them that Yedding gives no support on Sundays and that your on-site contact is their contact for the day. Payments, the security deposit, payouts and disputes work the same as on any other day.'
    },
    {
      heading: '6. Your responsibility.',
      text: "You are fully responsible for running each Sunday Event on the day. To the fullest extent the law allows, you release Yedding, LLC from claims that come from how a Sunday Event is run on the day, and the indemnity in our Terms of Service applies. This does not change the booker's duty to pay for damage they cause (Host Terms, section 3)."
    },
    {
      heading: '7. Insurance.',
      text: "The booker's insurance rules apply as on any day: events over 50 guests, and any event that serves alcohol, need insurance that lists you and Yedding, LLC as additional insured. You confirm that your own insurance covers events you host, including on Sundays."
    },
    {
      heading: '8. Closing Sundays.',
      text: 'You can close Sundays at any time in your venue editor. Closing stops new Sunday bookings. You stay responsible for every Sunday Event that is already booked, under these terms.'
    },
    {
      heading: '9. When we change these terms.',
      text: 'We will email you when these terms change. Your Sundays then close to new bookings until you agree to the new version. A Sunday Event already booked follows the version you last agreed to. Once you agree to a new version, it applies to all your Sunday Events that have not happened yet.'
    },
    {
      heading: '10. Our record.',
      text: 'Each time you open or close Sundays, we keep a record of the date and time, your account, the version you agreed to, and the on-site contact you gave. You can see the version you agreed to, and when, in your venue editor.'
    },
    {
      heading: '11. All your venues.',
      text: 'Your choice covers every venue in your Yedding account, including venues you add later. To keep a Sunday closed at one venue, block that date on its calendar.'
    }
  ],
  agree: 'I have read the Sunday Terms and I agree to them for all my venues.'
};

export default terms;
